import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=b079bf1a&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=b079bf1a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b079bf1a')) {
      api.createRecord('b079bf1a', component.options)
    } else {
      api.reload('b079bf1a', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=b079bf1a&", function () {
      api.rerender('b079bf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Gravame/Register.vue"
export default component.exports